<template>
  <v-skeleton-loader type="image" />
</template>

<script lang="ts">
import { defineComponent } from "vue"

export default defineComponent({
  name: "DefaultSkeletonLoader",
})
</script>
